import React, { Component } from 'react';
import { message, Upload, Spin } from 'antd';
import { Pagination, Breadcrumb, Select } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import { apis } from '../api/index.js';
import './demo.css';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';

import icon02 from './imgs/icon02.png';
import icon04 from './imgs/icon04.png';
// import download from './imgs/download.png';
import downloadUrl1 from './download/dicom_demo_1.zip';
import i18n from 'i18next';
import { formatDA, breadBack, changeListWidth, breadItem } from '../utils';
const { Option } = Select;

class UploadFrom extends Component {
  static propTypes = {
    server: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      loadingShow: false,
      tipText: '文件上传中，请稍候...',
      fileList: [],
      defaultFileList: [],
      emptyShow: true,
      aihisList: [],
      total: 0,
      uploadType: null,
      lastNum: 0,
      currentList: '',
      listWidth: 'calc(87% - 8px)',
      demoProductList: [],
    };
  }

  static propTypes = {
    history: PropTypes.object,
    setHeatmapDataSource: PropTypes.func.isRequired,
  };

  componentDidMount() {
    document.addEventListener('contextmenu', this.handleContextMenu);
    document.addEventListener('click', this.handleClick);
    this.getProductsForDemo();
  }

  getProductsForDemo = () => {
    let products = window.store.getState().api.user.info.products;
    products = products.filter(item => item.productId !== 1001 && item.isAuth);

    const type = products.length > 0 ? products[0].productId : null;
    this.setState(
      {
        demoProductList: products,
        uploadType: type,
      },
      () => {
        this.getLastNum(type);
        this.getAihis();
      }
    );
  };

  handleContextMenu = e => {
    e.preventDefault();
    const path = e.path;
    let flag = false,
      list;
    path.forEach(item => {
      if (item.className === 'list') {
        flag = true;
        list = item;
      }
    });
    if (flag) {
      this.setState({ currentList: list });
      const x = e.clientX;
      const y = e.clientY;
      document.getElementById('alertMenu').style.left = `${x}px`;
      document.getElementById('alertMenu').style.top = `${y}px`;
      document.getElementById('alertMenu').style.display = 'block';
    } else {
      document.getElementById('alertMenu').style.display = 'none';
    }
  };

  handleClick = e => {
    if (document.getElementById('alertMenu')) {
      const path = e.path || [];
      path.forEach(item => {
        if (item.className === 'alert-li') {
          const list = this.state.currentList;
          if (list) {
            const study_uid = list.getAttribute('data-studyuid');
            const series_uid = list.getAttribute('data-seriesuid');
            const sop_instance_uid = list.getAttribute('data-sopinstanceid');
            if (!study_uid || !series_uid || !sop_instance_uid) {
              message.warning('非标准DICOM格式图像，敬请期待');
              return;
            }
            const url = `/heatmap?objects=[{"StudyUid":"${study_uid}","SeriesUid":"${series_uid}","ObjectUid":"${sop_instance_uid}"}]&type=${this.state.uploadType}`;

            window.open(url, '_blank');
          }
        }
      });
      document.getElementById('alertMenu').style.display = 'none';
    }
  };

  getLastNum = type => {
    const post = { aiProductType: type };
    apis.remainings(post).then(result => {
      if (result.code === '0') {
        this.setState({ lastNum: result.data });
      } else {
        message.error(result.message);
        if (result.code === '1009') this.props.history.push('/login');
      }
    });
  };

  checkResultStatus = (study_uid, series_uid, sop_instance_uid) => {
    const _this = this;
    const result = setInterval(function() {
      const post = {
        study_uid,
        series_uid,
        sop_instance_uid,
        aiProductType: _this.state.uploadType,
      };
      apis.getAiResult(post).then(res => {
        if (res.code === '0') {
          clearInterval(result);
          _this.setState({ fileList: [], defaultFileList: [] });
          _this.props.setHeatmapDataSource(res.data);
          _this.getAihis();
          setTimeout(function() {
            message.success('解析成功，点击链接前往查看');
            _this.setState({ loadingShow: false });
          }, 2000);
        } else {
          message.error(res.message);
          if (res.code === '1009') this.props.history.push('/login');
        }
      });
    }, 1000);
  };

  download = () => {
    window.location.href = downloadUrl1;
  };

  getAihis = (page = 1) => {
    const rows = 10;
    const { uploadType } = this.state;
    const post = {
      offset: (page - 1) * rows,
      rows,
      aiProductType: uploadType,
    };
    apis.aihis(post).then(result => {
      if (result.code === '0') {
        this.setState({
          aihisList: result.data.list,
          total: result.data.total,
          emptyShow: false,
        });
      } else if (result.code === '1009') {
        this.props.history.push('/login');
      } else {
        this.setState({ aihisList: [], total: 0, emptyShow: true });
      }
    });
  };

  viewHeatmap = item => {
    const xpwidth = window.screen.width - 10;
    const xpheight = window.screen.height - 105;
    const study_uid = item.studyUid;
    const series_uid = item.seriesUid;
    const sop_instance_uid = item.sopInstanceId;
    if (!study_uid || !series_uid || !sop_instance_uid) {
      message.warning('非标准DICOM格式图像，敬请期待');
      return;
    }
    const url = `/heatmap?objects=[{"StudyUid":"${study_uid}","SeriesUid":"${series_uid}","ObjectUid":"${sop_instance_uid}"}]&type=${this.state.uploadType}`;
    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${xpwidth},height=${xpheight}`;
    window.open(url, 'viewer', str);
  };

  handleChange = value => {
    this.setState({ uploadType: value });
    const _this = this;
    setTimeout(function() {
      _this.getAihis(1, value);
      _this.getLastNum(value);
    }, 1);
  };
  setBackEvent = () => {
    // this.setSearchEvent('ns-066');
  };
  render() {
    const _this = this;
    const props = {
      name: 'dicomFile',
      // accept: 'dcm',
      multiple: false,
      showUploadList: this.state.loadingShow,
      defaultFileList: [],
      action: `/ai-web/dicom/upload?aiProductType=${this.state.uploadType}`,
      beforeUpload: file => {
        const fileTypes = ['image/png', 'image/jpg', 'image/jpeg'];
        let isType = fileTypes.includes(file.type);
        if (!isType && file.name.indexOf('.dcm') > 0) {
          isType = true;
        }
        if (!isType) {
          message.warning('不支持的文件格式');
        }
        return isType;
        // if(fileTypes.includes(file.type))
      },
      onChange: info => {
        const { status } = info.file;
        _this.setState({ emptyShow: false });
        if (status === 'uploading') {
          _this.setState({
            loadingShow: true,
            tipText: '文件上传中，请稍候...',
          });
        }

        if (status === 'done') {
          const data = info.file.response;
          if (data.code === '0') {
            message.success(`${info.file.name} 文件上传成功.`);
            _this.setState({
              loadingShow: true,
              tipText: '文件上传成功，等待AI解析...',
              fileList: info.fileList,
            });
            const studyUid = data.data.study_uid;
            const seriesUid = data.data.series_uid;
            const sopInstanceUid = data.data.sop_instance_uid;
            _this.checkResultStatus(studyUid, seriesUid, sopInstanceUid);
          } else {
            if (data.code === '1009') _this.props.history.push('/login');

            message.warning(data.message);
            _this.setState({ loadingShow: false });
            _this.getAihis();
          }
        } else if (status === 'error') {
          info.fileList = [];
          message.error(`${info.file.name} 文件上传失败.`);
          _this.setState({ loadingShow: false });
        }
      },
    };
    const { Dragger } = Upload;

    const { aihisList, demoProductList, uploadType } = this.state;
    let historyList = [];
    for (var i in aihisList) {
      historyList.push(
        <li
          className="list right-click"
          key={i}
          onClick={this.viewHeatmap.bind(this, aihisList[i])}
          data-studyuid={aihisList[i].studyUid}
          data-seriesuid={aihisList[i].seriesUid}
          data-sopinstanceid={aihisList[i].sopInstanceId}
        >
          <p>{aihisList[i].uploadFileName}</p>
          <p>{formatDA(aihisList[i].createTime)}</p>
        </li>
      );
    }
    return (
      <div className="form-bg">
        <ConnectedMenu toggleCollapsed={changeListWidth.bind(this, this)} />

        <div className="theme-content">
          <ConnectedHeader
            toggleCollapsed={changeListWidth.bind(this, this)}
            login={false}
            home={true}
          />

          <ul className="alert-menu" id="alertMenu">
            <li className="alert-li">
              <p>在新窗口打开</p>
            </li>
          </ul>
          <div className="theme-box">
            <div className="bread-crumb">
              <Breadcrumb>{breadItem(['在线试用'])}</Breadcrumb>
              {breadBack(this)}
            </div>
            <div className="box" style={{ width: this.state.listWidth }}>
              <div className="left-title">
                <span>试用产品选择</span>
                <Select
                  style={{ width: 500 }}
                  // defaultValue={this.state.uploadType}
                  value={this.state.uploadType}
                  onChange={this.handleChange}
                  allowClear={true}
                >
                  {demoProductList.map((item, index) => (
                    <Option key={index} value={item.productId}>
                      {i18n.t(item.productName)}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="demo-cnt">
                <div className="demo-left">
                  <div className="upload-file">
                    <Dragger {...props}>
                      <p className="ant-upload-drag-icon">
                        <img src={icon02} alt="" />
                      </p>
                      <p className="ant-upload-text">点击此处上传胸片</p>
                      <p className="ant-upload-hint">
                        支持单张胸片上传，不支持上传其他格式文件
                      </p>
                    </Dragger>
                  </div>
                  <div className="left-tips">
                    <p className="title">
                      上传胸部正位X光片DICOM文件，实时查看我们最新算法的结果
                    </p>
                    <p className="text">
                      {uploadType === 9 && (
                        <span>
                          这是一款使用我们最先进深度学习技术开发的在线胸片常見疾病（病变）AI筛查，可以准确地检测肺结核、肺炎、结节肿块和胸膜胸腔病变。检测到的病灶的位置通过概率热图高亮显示并给出“正异评分”，反映检测的病灶为异常病灶（肺结核、肺炎、结节肿块、胸膜胸腔）的概率。
                        </span>
                      )}
                      {uploadType === 11 && (
                        <span>
                          算法对数字X线胸⽚进行分析，判断该图像的肺结核疑似度，并通过概率热图⾼亮定位疑似病灶位置
                        </span>
                      )}
                    </p>
                  </div>
                </div>
                <div className="demo-right">
                  <span className="right-span">
                    剩余上传次数：{this.state.lastNum}
                  </span>
                  <div className="history-list history-list-demo">
                    {this.state.fileList.length === 0 &&
                    this.state.defaultFileList.length === 0 &&
                    this.state.emptyShow ? (
                      <div className="empty">
                        <p>
                          <img src={icon04} alt="" />
                        </p>
                        <p>暂无报告，请上传胸片体验</p>
                      </div>
                    ) : (
                      <>
                        <ul className="list-ul" id="list">
                          {historyList}
                        </ul>
                        <Pagination
                          onChange={this.getAihis}
                          size="small"
                          total={this.state.total}
                          pageSize={10}
                        ></Pagination>
                      </>
                    )}
                  </div>
                </div>

                {/* <div className="download-file">
                  <div className="down-link" onClick={this.download}>
                    <p>
                      <img src={download} alt="" />
                    </p>
                    <p className="down-tip1">点击此处下载</p>
                    <p className="down-tip">
                      如果您没有胸片，我们提供了胸片供您体验。
                    </p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {this.state.loadingShow && (
          <div className="loading-bg">
            <Spin tip={this.state.tipText} size="large"></Spin>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(UploadFrom);
